module.exports = __webpack_public_path__ + "img/ex8.8709960b.png";